import React from 'react';
import BaseComponent from './BaseComponent';
import { Form, Button } from 'antd';

class FormComponent extends BaseComponent {
  constructor(props) {
    super(props);
  }

  Field = (props) => {
    const { getFieldDecorator } = this.props.form;

    return (
      <Form.Item
        {...props}
        //        hasFeedback
      >
        {getFieldDecorator(props.name, props.options)(
          React.Children.only(props.children)
        )}
      </Form.Item>
    )
  }

  Submit = (props) => {
    return(
      <Form.Item>
        <Button
          type="success"
          htmlType="submit"
          {...props}
        >{props.children}</Button>
      </Form.Item>
    )
  }
}


export default FormComponent;


// WEBPACK FOOTER //
// ./src/components/FormComponent.js